import { connect } from 'react-redux';
import { pruneGroupProductHistory, selectEventsByGroupId } from '~/GroupProductHistory';
import HistoryTable from '~/ProductHistoryTable/HistoryTable';
import { ProductHistoryEvent } from '~/Api/Product/History';

import { fetch } from './actions';
import { State } from '~/Store';

const mapStateToProps = (
	state: State,
	props: {
		groupId: string;
	}
): {
	id: string;
	isFetching: boolean;
	events: ProductHistoryEvent[];
	hasNextPage: boolean;
	productHistoryLink: (link: string) => string;
} => {
	const history = selectEventsByGroupId(state.groupProductHistory, props.groupId);

	return {
		id: props.groupId,
		isFetching: Boolean(history?.isFetching),
		events: history?.events || [],
		hasNextPage: Boolean(history?.pagination?.hasNextPage()),
		productHistoryLink: (productId: string) =>
			`/product-groups/${encodeURIComponent(props.groupId)}/${encodeURIComponent(productId)}/history`,
	};
};

const actions: {
	onFetch: typeof fetch;
	onPrune: typeof pruneGroupProductHistory;
} = {
	onFetch: fetch,
	onPrune: pruneGroupProductHistory,
};

export default connect(mapStateToProps, actions)(HistoryTable);
